import React from 'react';
import {
  Divider,
  QuestionAnswer,
  QuestionAnswerVariant,
  Stack,
} from '@grubhubprod/gh-cookbook-react';
import type { GroceriesFaqItemData } from 'src/components/enterprise/features/Groceries/constants/groceriesContent';

interface GroceriesFaqItemProps {
  faq: GroceriesFaqItemData;
  showDivider: boolean;
}

export function GroceriesFaqItem({
  faq,
  showDivider,
}: GroceriesFaqItemProps): JSX.Element {
  return (
    <>
      <Stack y="sm">
        <QuestionAnswer
          variant={QuestionAnswerVariant.VARIANT_2}
          question={faq.question}
          answer={faq.answer}
        />
      </Stack>
      {showDivider && (
        <Stack y="sm">
          <Divider />
        </Stack>
      )}
    </>
  );
}
